import axios from 'axios';

import { API_ROOT_URL, API_URL, API_TOKEN } from 'utils/globals';

const headers = {
  common: {
    Authorization: `Token token="${API_TOKEN}"`,
  },
};

export default axios.create({ baseURL: API_URL, headers });

export const rootAPI = axios.create({
  baseURL: API_ROOT_URL,
  headers,
});
